import { useEffect, useState } from 'react';

import { useToastErrorHandler } from '@collab/libs/errors';

import { getApiApplicationSecrets } from 'features/applications/applications.api';
import {
  getVolvoIdAccessToken,
  removeVolvoIdAccessToken,
} from 'libs/volvoId/volvoIdAccessToken';

import { useSwagger } from '../SwaggerProvider';
import { useTryItOut } from './TryItOutProvider';
import { getApplicationId, removeApplicationId } from './applicationIdSession';
import { errorMsg } from './swagger.constants';
import useAuthorizeSwagger from './useAuthorizeSwagger';

const usePostVolvoidLogin = (apiId: string, onPostRedirect: () => void) => {
  const { isLoading: swaggerIsLoading } = useSwagger();
  const authorize = useAuthorizeSwagger();
  const [isLoading, setIsLoading] = useState(false);
  const handleWithToast = useToastErrorHandler();
  const { setAuthorizedState } = useTryItOut();

  useEffect(() => {
    if (!swaggerIsLoading) {
      postVolvoidLogin();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [swaggerIsLoading]);

  const postVolvoidLogin = async () => {
    const token = getVolvoIdAccessToken();

    if (!token) {
      return null;
    }

    const applicationId = getApplicationId();
    const volvoIdAccessToken = getVolvoIdAccessToken();

    if (!applicationId || volvoIdAccessToken?.apiName !== apiId) {
      return;
    }

    onPostRedirect();

    try {
      setIsLoading(true);
      const secrets = await getApiApplicationSecrets(applicationId);

      authorize(secrets.primary, token.token.accessToken);

      setAuthorizedState('volvoid');
    } catch (e) {
      handleWithToast(e, errorMsg);
    } finally {
      removeApplicationId();
      removeVolvoIdAccessToken();
      setIsLoading(false);
    }
  };

  return { isLoading };
};

export default usePostVolvoidLogin;
